import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { OsobaOrganizacie } from '../models';
// @ts-ignore
import { Subjekt } from '../models';
/**
 * PortalPouzivatelApi - axios parameter creator
 * @export
 */
export const PortalPouzivatelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Zvolenie subjektu po prihlásení
         * @param {string} subjektId Subjekt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSubjektToPouzivatelPortalPouzivatel: async (subjektId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('assignSubjektToPouzivatelPortalPouzivatel', 'subjektId', subjektId)
            const localVarPath = `/prirad-subjekt/{subjektId}`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Kontrola neoverených osôb na subjekte - organizácii po prihlásení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkNeovereneOsobyPortalPouzivatel: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subjekty/osoby-organizacie-neoverene-existuju`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vráti neoverené osoby organizácie pre prihlásený subjekt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeovereneOsobyOrganizaciePortalPouzivatel: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subjekty/osoby-organizacie-neoverene`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ponuka subjektov po prihlásení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatelSubjektyPortalPouzivatel: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subjekty/autorizovane`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vráti osobu organizácie pre prihláseného používateľa a zvolený subjekt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrihlasenaOsobaOrganizaciePortalPouzivatel: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subjekty/prihlasena-osoba-organizacie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pozastavenie činnosti neoverených osôb na subjekte - organizácii po prihlásení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendOsobyOrganizaciePortalPouzivatel: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subjekty/osoby-organizacie-pozastav-cinnost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortalPouzivatelApi - functional programming interface
 * @export
 */
export const PortalPouzivatelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortalPouzivatelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Zvolenie subjektu po prihlásení
         * @param {string} subjektId Subjekt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignSubjektToPouzivatelPortalPouzivatel(subjektId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignSubjektToPouzivatelPortalPouzivatel(subjektId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Kontrola neoverených osôb na subjekte - organizácii po prihlásení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkNeovereneOsobyPortalPouzivatel(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkNeovereneOsobyPortalPouzivatel(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Vráti neoverené osoby organizácie pre prihlásený subjekt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNeovereneOsobyOrganizaciePortalPouzivatel(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OsobaOrganizacie>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNeovereneOsobyOrganizaciePortalPouzivatel(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ponuka subjektov po prihlásení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPouzivatelSubjektyPortalPouzivatel(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Subjekt>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPouzivatelSubjektyPortalPouzivatel(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Vráti osobu organizácie pre prihláseného používateľa a zvolený subjekt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrihlasenaOsobaOrganizaciePortalPouzivatel(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OsobaOrganizacie>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrihlasenaOsobaOrganizaciePortalPouzivatel(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Pozastavenie činnosti neoverených osôb na subjekte - organizácii po prihlásení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suspendOsobyOrganizaciePortalPouzivatel(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OsobaOrganizacie>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suspendOsobyOrganizaciePortalPouzivatel(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PortalPouzivatelApi - factory interface
 * @export
 */
export const PortalPouzivatelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortalPouzivatelApiFp(configuration)
    return {
        /**
         * 
         * @summary Zvolenie subjektu po prihlásení
         * @param {string} subjektId Subjekt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSubjektToPouzivatelPortalPouzivatel(subjektId: string, options?: any): AxiosPromise<void> {
            return localVarFp.assignSubjektToPouzivatelPortalPouzivatel(subjektId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Kontrola neoverených osôb na subjekte - organizácii po prihlásení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkNeovereneOsobyPortalPouzivatel(options?: any): AxiosPromise<boolean> {
            return localVarFp.checkNeovereneOsobyPortalPouzivatel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vráti neoverené osoby organizácie pre prihlásený subjekt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeovereneOsobyOrganizaciePortalPouzivatel(options?: any): AxiosPromise<Array<OsobaOrganizacie>> {
            return localVarFp.getNeovereneOsobyOrganizaciePortalPouzivatel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ponuka subjektov po prihlásení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatelSubjektyPortalPouzivatel(options?: any): AxiosPromise<Array<Subjekt>> {
            return localVarFp.getPouzivatelSubjektyPortalPouzivatel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vráti osobu organizácie pre prihláseného používateľa a zvolený subjekt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrihlasenaOsobaOrganizaciePortalPouzivatel(options?: any): AxiosPromise<Array<OsobaOrganizacie>> {
            return localVarFp.getPrihlasenaOsobaOrganizaciePortalPouzivatel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pozastavenie činnosti neoverených osôb na subjekte - organizácii po prihlásení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendOsobyOrganizaciePortalPouzivatel(options?: any): AxiosPromise<Array<OsobaOrganizacie>> {
            return localVarFp.suspendOsobyOrganizaciePortalPouzivatel(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortalPouzivatelApi - object-oriented interface
 * @export
 * @class PortalPouzivatelApi
 * @extends {BaseAPI}
 */
export class PortalPouzivatelApi extends BaseAPI {
    /**
     * 
     * @summary Zvolenie subjektu po prihlásení
     * @param {string} subjektId Subjekt ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalPouzivatelApi
     */
    public assignSubjektToPouzivatelPortalPouzivatel(subjektId: string, options?: AxiosRequestConfig) {
        return PortalPouzivatelApiFp(this.configuration).assignSubjektToPouzivatelPortalPouzivatel(subjektId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Kontrola neoverených osôb na subjekte - organizácii po prihlásení
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalPouzivatelApi
     */
    public checkNeovereneOsobyPortalPouzivatel(options?: AxiosRequestConfig) {
        return PortalPouzivatelApiFp(this.configuration).checkNeovereneOsobyPortalPouzivatel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vráti neoverené osoby organizácie pre prihlásený subjekt
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalPouzivatelApi
     */
    public getNeovereneOsobyOrganizaciePortalPouzivatel(options?: AxiosRequestConfig) {
        return PortalPouzivatelApiFp(this.configuration).getNeovereneOsobyOrganizaciePortalPouzivatel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ponuka subjektov po prihlásení
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalPouzivatelApi
     */
    public getPouzivatelSubjektyPortalPouzivatel(options?: AxiosRequestConfig) {
        return PortalPouzivatelApiFp(this.configuration).getPouzivatelSubjektyPortalPouzivatel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vráti osobu organizácie pre prihláseného používateľa a zvolený subjekt
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalPouzivatelApi
     */
    public getPrihlasenaOsobaOrganizaciePortalPouzivatel(options?: AxiosRequestConfig) {
        return PortalPouzivatelApiFp(this.configuration).getPrihlasenaOsobaOrganizaciePortalPouzivatel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pozastavenie činnosti neoverených osôb na subjekte - organizácii po prihlásení
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalPouzivatelApi
     */
    public suspendOsobyOrganizaciePortalPouzivatel(options?: AxiosRequestConfig) {
        return PortalPouzivatelApiFp(this.configuration).suspendOsobyOrganizaciePortalPouzivatel(options).then((request) => request(this.axios, this.basePath));
    }
}
